module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('OrderListDetails'), _vm._v(" "), _c('div', {
    staticClass: "all-sections"
  }, [_c('Timeline'), _vm._v(" "), _c('OrderMessage', {
    attrs: {
      "currencyBrand": _vm.orderData.currency,
      "dataComments": _vm.orderData.orderHistories
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aecff02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderMain/OrderMain.vue
// module id = 3005
// module chunks = 0